import { createAction } from 'redux-actions';
import localStore from 'store';
import * as actionType from './actionTypes';
import client from '../../apollo';
import eligibilityProductsQuery from '../../graphql/eligibilityProductsQuery';
import eligibilityRulesQuery from '../../graphql/eligibilityRulesQuery';

export const setProducts = createAction(actionType.SET_PRODUCTS);
export const setProductsLoading = createAction(actionType.SET_PRODUCTS_LOADING);
export const setProductsError = createAction(actionType.SET_PRODUCTS_ERROR);
export const setSelectedProduct = createAction(actionType.SET_SELECTED_PRODUCT);
export const setRules = createAction(actionType.SET_RULES);
export const setRulesLoading = createAction(actionType.SET_RULES_LOADING);
export const setRulesError = createAction(actionType.SET_RULES_ERROR);
export const setNextEffectiveFrom = createAction(
  actionType.SET_NEXT_EFFECTIVE_FROM
);
export const setHasUnsavedChanges = createAction(
  actionType.SET_HAS_UNSAVED_CHANGES
);
export const updateRule = createAction(actionType.UPDATE_RULE);
export const setPendingActivation = createAction(
  actionType.SET_PENDING_ACTIVATION
);

export const fetchProducts = () => async dispatch => {
  dispatch(setProductsLoading(true));
  try {
    const result = await client.query({
      query: eligibilityProductsQuery,
      fetchPolicy: 'network-only',
    });
    const productsData = result.data.externalProducts || [];
    dispatch(setProducts(productsData));
    // Determine the product to select: prefer the one saved in localStorage
    // (if it still exists in the list), otherwise fall back to the first product.
    const savedProduct = localStore.get('eligibilitySelectedProduct');
    const productToSelect = savedProduct && productsData.some(p => p.categoryCode === savedProduct)
      ? savedProduct
      : productsData[0]?.categoryCode || '';
    dispatch(setSelectedProduct(productToSelect));
  } catch (err) {
    // Reducer will stop loading when SET_PRODUCTS_ERROR is dispatched.
    dispatch(setProductsError(err));
  }
};

const toLocalISOString = utcString => {
  // Force parsing as UTC: append 'Z' if no timezone designator is present
  const normalized = /[-Z+]\d*$/.test(utcString) ? utcString : `${utcString}Z`;
  const date = new Date(normalized);
  const offsetMs = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offsetMs).toISOString().replace('Z', '');
};

export const fetchRules = productCode => async dispatch => {
  if (!productCode) return;
  dispatch(setRulesLoading(true));
  dispatch(setRulesError(null));
  dispatch(setNextEffectiveFrom(null));
  try {
    const nextResult = await client.query({
      query: eligibilityRulesQuery,
      variables: { productCode: String(productCode), configType: 'NEXT' },
      fetchPolicy: 'network-only',
    });
    const nextConfig = nextResult.data.externalRulesByProductCode;
    if (nextConfig && nextConfig.effectiveFrom != null) {
      dispatch(setRules(nextConfig.rules || []));
      dispatch(
        setNextEffectiveFrom(toLocalISOString(nextConfig.effectiveFrom))
      );
    } else {
      const activeResult = await client.query({
        query: eligibilityRulesQuery,
        variables: { productCode: String(productCode), configType: 'ACTIVE' },
        fetchPolicy: 'network-only',
      });
      const activeConfig = activeResult.data.externalRulesByProductCode;
      dispatch(setRules((activeConfig && activeConfig.rules) || []));
      dispatch(setNextEffectiveFrom(null));
    }
  } catch (err) {
    dispatch(setRulesError(err));
  } finally {
    dispatch(setRulesLoading(false));
  }
};
